import { c as _c } from "react/compiler-runtime";
import { FormLabel, Stack, TextField, Typography, FormControl, type SxProps } from '@mui/material';
import { useState } from 'react';
import type React from 'react';
import { HelpIcon } from '@/components/shared/helpIcon';
import type { FieldValidation } from './validation/fieldValidation';
import { InputErrorIcon } from './validation/inputErrorIcon';
export const FormTextField = t0 => {
  const $ = _c(38);
  const {
    size: t1,
    testId,
    title,
    helpText,
    alwaysShowHelp: t2,
    dataTestId,
    validation,
    placeholder,
    value,
    onChange,
    sx,
    disabled: t3
  } = t0;
  const size = t1 === undefined ? "medium" : t1;
  const alwaysShowHelp = t2 === undefined ? false : t2;
  const disabled = t3 === undefined ? false : t3;
  const [touched, setTouched] = useState(false);
  let t4;
  if ($[0] !== touched || $[1] !== validation || $[2] !== value) {
    t4 = touched && (validation ? !validation.validateInput(value) : false);
    $[0] = touched;
    $[1] = validation;
    $[2] = value;
    $[3] = t4;
  } else {
    t4 = $[3];
  }
  const hasError = t4;
  let t5;
  if ($[4] !== sx) {
    t5 = {
      width: "100%",
      ...sx
    };
    $[4] = sx;
    $[5] = t5;
  } else {
    t5 = $[5];
  }
  let t6;
  if ($[6] !== alwaysShowHelp || $[7] !== helpText || $[8] !== title) {
    t6 = title && <FormLabel><Stack direction="row" alignItems="center" justifyContent="space-between"><Typography variant="subtitle1">{title}</Typography>{helpText && <HelpIcon title={helpText} alwaysVisible={alwaysShowHelp} className="text-(--mui-palette-text-secondary)" />}</Stack></FormLabel>;
    $[6] = alwaysShowHelp;
    $[7] = helpText;
    $[8] = title;
    $[9] = t6;
  } else {
    t6 = $[9];
  }
  let t7;
  if ($[10] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = () => setTouched(true);
    $[10] = t7;
  } else {
    t7 = $[10];
  }
  const t8 = hasError ? "4px" : "24px";
  let t9;
  if ($[11] !== t8) {
    t9 = {
      "& .MuiInputBase-root": {
        paddingRight: t8
      }
    };
    $[11] = t8;
    $[12] = t9;
  } else {
    t9 = $[12];
  }
  let t10;
  if ($[13] !== dataTestId) {
    t10 = {
      ...(dataTestId ? {
        "data-testid": dataTestId
      } : {})
    };
    $[13] = dataTestId;
    $[14] = t10;
  } else {
    t10 = $[14];
  }
  let t11;
  if ($[15] !== hasError || $[16] !== validation || $[17] !== value) {
    t11 = hasError && <InputErrorIcon errorMessage={validation?.errorMessage(value)} />;
    $[15] = hasError;
    $[16] = validation;
    $[17] = value;
    $[18] = t11;
  } else {
    t11 = $[18];
  }
  let t12;
  if ($[19] !== t11) {
    t12 = {
      endAdornment: t11
    };
    $[19] = t11;
    $[20] = t12;
  } else {
    t12 = $[20];
  }
  let t13;
  if ($[21] !== t10 || $[22] !== t12) {
    t13 = {
      htmlInput: t10,
      input: t12
    };
    $[21] = t10;
    $[22] = t12;
    $[23] = t13;
  } else {
    t13 = $[23];
  }
  let t14;
  if ($[24] !== disabled || $[25] !== hasError || $[26] !== onChange || $[27] !== placeholder || $[28] !== size || $[29] !== t13 || $[30] !== t9 || $[31] !== testId || $[32] !== value) {
    t14 = <TextField size={size} data-testid={testId} onBlur={t7} error={hasError} sx={t9} slotProps={t13} placeholder={placeholder} disabled={disabled} value={value} onChange={onChange} />;
    $[24] = disabled;
    $[25] = hasError;
    $[26] = onChange;
    $[27] = placeholder;
    $[28] = size;
    $[29] = t13;
    $[30] = t9;
    $[31] = testId;
    $[32] = value;
    $[33] = t14;
  } else {
    t14 = $[33];
  }
  let t15;
  if ($[34] !== t14 || $[35] !== t5 || $[36] !== t6) {
    t15 = <FormControl className="group/help" sx={t5}>{t6}{t14}</FormControl>;
    $[34] = t14;
    $[35] = t5;
    $[36] = t6;
    $[37] = t15;
  } else {
    t15 = $[37];
  }
  return t15;
};